import React from "react";
import { Router, Switch, Redirect } from "react-router-dom";
import RouteComponent from "./route-config.jsx";
import { UrlCollectionSarang } from "./common/url-collection-sarang";
import history from "./common/history";
import ReactGA from "react-ga4";

// Components
import AppLoading from "./components/loading/loading.view";
import DialogWarningExpired from "./components/dialog-warning-expired/dialog-warning-expired.view";
import LockScreen from "./components/lock-screen/lock-screen.view.jsx";

// Routes configuration
import { allRoutes } from "./routes";

function App() {
    ReactGA.initialize("G-82Y8T19K4Y");

    return (
        <div>
            <DialogWarningExpired />
            <Router history={history}>
                <AppLoading />
                <LockScreen />
                <Switch>
                    {/* Default Redirect */}
                    <Redirect
                        exact
                        from="/"
                        to={UrlCollectionSarang.CuisineOrder}
                    />
                    
                    {/* Application Routes */}
                    {allRoutes.map((route, index) => (
                        <RouteComponent
                            key={index}
                            exact={route.exact}
                            path={route.path}
                            component={route.component}
                            layout={route.layout}
                            isSetActive={route.isSetActive}
                        />
                    ))}

                    {/* Fallback Redirect */}
                    <Redirect to={UrlCollectionSarang.CuisineOrder} />
                </Switch>
            </Router>
        </div>
    );
}

export default App;
